import { useSyncExternalStore } from 'react';

export const ANIMATION_WORD_DELAY_MS = 100;
export const ANIMATION_START_DELAY_MS = 550;
export const FEEDBACK_LINKS_INITIAL_DELAY_MS = 180;

export function getFeedbackStorageKey(petitionId: string): string {
	return `ai_summary_feedback_${petitionId}`;
}

export function hasStoredFeedback(petitionId: string): boolean {
	try {
		return localStorage.getItem(getFeedbackStorageKey(petitionId)) === 'true';
	} catch {
		return false;
	}
}

export function storeFeedback(petitionId: string): void {
	try {
		localStorage.setItem(getFeedbackStorageKey(petitionId), 'true');
	} catch {
		// localStorage may be unavailable (private browsing, storage quota, etc.)
	}
}

const NOOP_SUBSCRIBE = () => () => {};

export function useHasStoredFeedback(petitionId: string): boolean | null {
	return useSyncExternalStore(
		NOOP_SUBSCRIBE,
		() => hasStoredFeedback(petitionId),
		() => null,
	);
}
